import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Response2ResponseData } from "./common";
/**
 * Getters
 */
export const _UserEntitlementGetter = Getter.of();
export const _UserEntitlementResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _UserEntitlementResponse2UserEntitlement = _Response2ResponseData();
export const _UserEntitlement2Data = Fold.compose(_UserEntitlementGetter, Res._Response());
export const _UserEntitlement2Attributes = Fold.compose(_UserEntitlement2Data, Lens.prop("attributes"));
export const _UserEntitlementAttributes2HasActiveAcquiredCapabilities = Fold.compose(_UserEntitlement2Attributes, Lens.prop("hasActiveAcquiredCapabilities"));
export const _UserEntitlementAttributes2HasExpiredAcquiredCapabilities = Fold.compose(_UserEntitlement2Attributes, Lens.prop("hasExpiredAcquiredCapabilities"));
export const _UserEntitlementAttributes2AdStrategies = Fold.compose(_UserEntitlement2Attributes, Lens.prop("adStrategies"));
export const _UserEntitlementAttributes2HasOfflineViewing = Fold.compose(_UserEntitlement2Attributes, Lens.prop("hasOfflineViewing"));

